import { render } from "./neko.vue?vue&type=template&id=dcc50fc0&scoped=true"
import script from "./neko.vue?vue&type=script&lang=js"
export * from "./neko.vue?vue&type=script&lang=js"

import "./neko.vue?vue&type=style&index=0&id=dcc50fc0&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcc50fc0"]])

export default __exports__